export default "__VITE_ASSET__XdDcL$hB__"